import { render, staticRenderFns } from "./DeactiveModal.vue?vue&type=template&id=21f0b592&"
import script from "./DeactiveModal.vue?vue&type=script&lang=js&"
export * from "./DeactiveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports